import classNames from "classnames";
import { PhosphorWarningCircle } from "components/Atoms/PhosphorIcon";
import moment from "moment";
import React from "react";
import { cdn } from "utilities/cdnUtils";

const PaymentMethodIcon = ({ paymentMethod, width }: { paymentMethod: server.dto.ClientPaymentMethod, width: number }) => {
  const { type, brand } = paymentMethod;

  if (type === "invoice") return <div className="margin-right"><i className="icon-file-text" /></div>;
  if (type === "sepaDebit") return <div className="margin-right"><i className="icon-eur" /></div>;

  let imgSrc = null;

  //   if (type === "sepaDebit") imgSrc = "sepa";
  if (type === "card" && brand === "amex") imgSrc = "amex";
  if (type === "card" && brand === "mastercard") imgSrc = "mastercard";
  if (type === "card" && brand === "visa") imgSrc = "visa";

  return imgSrc == null
    ? <></>
    : <div className="margin-right"><img src={cdn.static(`/images/paymentmethod/${imgSrc}.png`)} style={{ width }} /></div>;
};

const ClientPaymentMethod = ({ paymentMethod }: { paymentMethod: server.dto.ClientPaymentMethod }) => {
  const { type, brand, last4, expMonth, expYear, hasProblem } = paymentMethod;

  const classes = classNames("padding-large flex",
    {
      "panel-bg-color": !hasProblem,
      "lightred-bg": hasProblem
    });
  return <div className={classes}>

    <PaymentMethodIcon paymentMethod={paymentMethod} width={50} />

    <div className="grow1">
      <div className="margin-bottom-small">
        <h3>
          {type === "card" && <>{brand} •••• {last4}</>}
          {type === "invoice" && <>{RESX.Invoice.xInvoice}</>}
          {type === "sepaDebit" && <>{RESX.PaymentMethods.SepaDebit} •••• {last4}</>}
        </h3>
      </div>
      {type === "card" && <div className="s1_gray">{RESX.Payment.Expires} {moment.monthsShort(expMonth - 1)} {expYear}</div>}
    </div>

    {hasProblem && <div><PhosphorWarningCircle iconColor="error" iconSize="large" /></div>}
  </div >;
};

export default ClientPaymentMethod;
